import { render, staticRenderFns } from "./safe-ware-table.vue?vue&type=template&id=6c34f490&"
import script from "./safe-ware-table.vue?vue&type=script&lang=js&"
export * from "./safe-ware-table.vue?vue&type=script&lang=js&"
import style0 from "./safe-ware-table.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports